import { Toolbar } from '@material-ui/core';
import React from 'react';
import { motion } from 'framer-motion';
import { useIsMobileAppKeyboardVisible } from '../mobile-app/useIsMobileAppKeyboardVisible';

import useStyles from './FundDetailsDialogBottomBar.style';

export interface FundDetailsDialogBottomBarProps {
  fullWidth?: boolean;
}

const FundDetailsDialogBottomBar: React.FC<FundDetailsDialogBottomBarProps> = ({children, fullWidth}) => {
  const isMobileAppKeyboardVisible = useIsMobileAppKeyboardVisible();
  const c = useStyles({ fullWidth, isMobileAppKeyboardVisible });

  const animateProps = {
    initial: { y: 300 },
    animate: { y: 0 },
    exit: { y: 300 },
    transition: { duration: 0.2 },
  }

  return (
    <motion.div className={c.root} {...animateProps} key="bottomBar">
      <Toolbar>
        <div className={c.container}>
          {children}
        </div>
      </Toolbar>
    </motion.div>
  );
};

export default FundDetailsDialogBottomBar;
